namespace GeniuzPOS.AdvPromo {
    export class LookupAvPromoCouponTypesColumns {
        static columnsKey = 'AdvPromo.LookupAvPromoCouponTypes';
    }
}
